// removed by extract-text-webpack-plugin
module.exports = {"FormSelect":"_1i1z9G5-Jb5-VMlfVWSUMN","FormSelect__label":"_1a_hw4swTirp6AMLo_i9Ua","Select":"_39kH3B97BlKbXsrT_-jHjg"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FormSelect/FormSelect.scss
// module id = 2612
// module chunks = 0